<template>
  <div>
    <basic-list
      :show-select-col="true"
      :show-action-col="false"
      :show-index-col="false"
      :show-col-set="false"
      select-type="singleMult"
      :fields="listFields"
      :loading="state.loading"
      :total="state.total"
      :list="state.list"
      :table-h="tableH"
      :page-index="state.pageIndex"
      :page-size="state.pageSize"
      :page-index-change="pageIndexChange"
      :page-size-change="pageSizeChange"
      :selection-change="selectionChange"
    >
      <template slot="hd-col--l">
        <el-button
          type="primary"
          size="mini"
          @click="onHandleAdd"
          v-if="buttonData('tjsjzy').has"
          >{{ buttonData("tjsjzy").name }}</el-button
        >
        <el-button size="mini" @click="onHandleEdit" v-if="buttonData('bjsjzy').has">{{
          buttonData("bjsjzy").name
        }}</el-button>
        <el-button
          type="danger"
          size="mini"
          @click="onHandleDetele"
          v-if="buttonData('scsjzy').has"
          >{{ buttonData("scsjzy").name }}</el-button
        >
        <!-- 导入 -->
        <el-button
          size="mini"
          @click="importData"
          v-if="buttonData('DRSJZY').has && this.showExportButton"
          >{{ buttonData("DRSJZY").name }}</el-button
        >
        <!-- 导出 -->
        <el-button
          size="mini"
          @click="exportOrg"
          v-if="buttonData('DCSJZY').has && this.showExportButton"
          >{{ buttonData("DCSJZY").name }}</el-button
        >
        <!-- 删除静态菜单
                <el-button type="primary" size="mini" @click="onHandleAdd">添加</el-button>
                <el-button type="primary" size="mini" @click="onHandleEdit">编辑</el-button>
                <el-button type="danger" size="mini" @click="onHandleDetele">删除</el-button>
                -->
      </template>
    </basic-list>

    <!--批量导入-->
    <import-dialog-new
      module-name=""
      :visible="dialogBool.val"
      :action="'导入数据资源'"
      :uploadData="uploadData"
      :entity="state.entity"
      :state="state"
      :win-close="() => (dialogBool.val = false)"
      :handle-save="() => {}"
    />
  </div>
</template>

<script>
import ExactList from "@/mixins/exactList";
import importDialogNew from "./importDialogNew";
import { mapState } from "vuex";

// 默认字段
const DEFAULTFIELDS = [
  {
    key: "ext1",
    name: window.__VM__.$t('language.5o6wazk04u80'),
    hidden: true,
  },
];
const CREATETIME = [
   {
    key: "dataCode",
    name: window.__VM__.$t('language.5o6v3o41zmg0'),
  },
  {
    key: "orgName",
    name: window.__VM__.$t('language.5o6trh9vmuo0'),
  },
  {
    key: "createTime",
    name: window.__VM__.$t('language.5o6otz4p1t00'),
    formatter: function (row, column, cellValue, index) {
      return jt.date.format(new Date(cellValue).getTime());
    },
  },
 
];
export default {
  computed: {
    ...mapState("app", ["showExportButton"]),
  },
  mixins: [ExactList],
  data() {
    return {
      currentRow: {},
      DEFAULTFIELDS: DEFAULTFIELDS,
      dialogBool: { val: false },
      uploadData: {},
    };
  },
  props: {
    exportOrg: Function,
    state: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: { importDialogNew },
  computed: {
    listFields() {
      const currentFiles =
        this.state.currentFiles && this.state.currentFiles.length
          ? [CREATETIME[0],..._.cloneDeep(this.state.currentFiles), ...CREATETIME.slice(1,CREATETIME.length)]
          : this.DEFAULTFIELDS;
      return currentFiles;
    },
  },
  methods: {
    importData() {
      this.dialogBool.val = true;
      this.uploadData = {
        uploadUrl: "/dataBaseBatch/importV2",
        templateType: "baseData",
        name: "baseDataFile",
      };
    },
    message(msg = `${this.$t('language.5o6wazk054w0')}`) {
      this.$message.error(msg);
    },
    selectionChange(rows) {
      this.selRows = rows;
      this.currentRow = rows.length ? rows[0] : {};
      this.handleSelectionChange && this.handleSelectionChange(rows);
    },
    onHandleAdd() {
      this.$parent.addChange();
      this.$parent.queryOrgTreeList().then((rows) => {
        // 设置为key-belongOrgId的options值
        tools.setKeys(this.state.DEFAULTFIELDS, "belongOrgId", rows, "options");
        if (!this.state.currentFiles) return;
        const length = this.state.currentFiles.length;
        if (length) {
          this.handleAdd();
        } else {
          this.message(`${this.$t('language.5o6wazk057c0')}`);
        }
      });
    },
    onHandleEdit() {
      const id = this.currentRow.id;

      if (id !== undefined) {
        this.$parent.editChange(id);
        this.$parent.queryOrgIdTreeList(id).then((rows) => {
          // 设置为key-belongOrgId的options值
          tools.setKeys(this.state.DEFAULTFIELDS, "belongOrgId", rows, "options");
          this.handleEdit({ id }, true);
        });
        // this.handleEdit(this.currentRow)
      } else {
        this.message();
      }
    },
    onHandleDetele() {
      const id = this.currentRow.id;
      if (id !== undefined) {
        this.handleDelete({ id });
      } else {
        this.message();
      }
    },
  },
};
</script>
